import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { toast } from '../components/Toast'
import axios from 'axios'
import { buildApiUrl, ENDPOINTS } from '../config/api'
import { AuthLogo } from '../components/Logo'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await axios.post(buildApiUrl(ENDPOINTS.FORGOT_PASSWORD), { email })
      setSent(true)
      toast('success', 'E-mail enviado!', 'Verifique sua caixa de entrada')
    } catch {
      toast('error', 'Erro', 'Não foi possível enviar o e-mail')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6">
      <div className="w-full max-w-sm">
        <AuthLogo />

        <h1 className="text-2xl font-bold text-gray-900 mb-1 text-center">Recuperar senha</h1>
        <p className="text-gray-500 mb-8 text-center">Enviaremos um link para redefinir sua senha</p>

        {sent ? (
          <div className="text-center bg-success-50 border border-success-200 rounded-lg p-6">
            <p className="text-success-800 font-medium mb-2">E-mail enviado com sucesso!</p>
            <p className="text-sm text-success-600">Verifique sua caixa de entrada e siga as instruções.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">E-mail</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="seu@email.com"
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none" />
            </div>
            <button type="submit" disabled={loading}
              className="w-full py-2.5 bg-brand-600 hover:bg-brand-700 text-white font-medium rounded-lg text-sm transition-colors disabled:opacity-50">
              {loading ? 'Enviando...' : 'Enviar link'}
            </button>
          </form>
        )}

        <Link to="/login" className="flex items-center gap-2 justify-center text-sm text-brand-600 hover:text-brand-700 font-medium mt-6">
          <ArrowLeft className="w-4 h-4" /> Voltar ao login
        </Link>
      </div>
    </div>
  )
}
